import store from "../../store";
import { configController } from "./config.controll";
import { Config } from "./config.model";

export const configState = () => {
    return store.getState().configState;
}

export const getConfigDataIniEstoque = () => {
    let configState = store.getState().configState;
    return configState.row.data_ini_estoque;
}

export const handleUpdateConfig = (row:Config) => {
    store.dispatch(configController.reducer.actions.update(row));
}